module.exports = __webpack_public_path__ + "static/media/low-vision.89117d51.svg";